<template>
  <div style="margin:20px 5px">
    <div v-if="courseDataArray.length === 0" style="margin:78px 0px 40px 0px;text-align: center">
      <img src="@/assets/img/none.png" width="240" height="240">
    </div>

    <el-card class="courseware-item" shadow="never"
             v-for="(courseData,index) in courseDataArray"
             :key="courseData.id"
             @click.native="toDownload(courseData.id)">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="18">
          {{index+1}}. {{courseData.name}}
        </el-col>
        <div class="download-tip"><i class="el-icon-download"></i></div>
        <el-col :span="2" style="text-align: right;margin-right: 5px">
          <span > {{parseInt(courseData.size ) | formatFileSize}}</span>
        </el-col>
      </el-row>
    </el-card>

  </div>
</template>

<script>
  export default {
    name: "CourseDataDownload",
    props: {
      courseDataArray:Array,
      courseId: String,
    },
    data() {
      return {

      }
    },
    methods: {
      async toDownload(id) {
        const data= await this.$http.get('/business/web/courseData/queryById',{
          params: {id:id}
        });
        let code = data.code;
        if (code === '2000') {
          let a = document.createElement('a');
          a.href = data.content;
          document.body.appendChild(a);
          a.click();
          a.remove()
        }else if (code === '2002') {
          this.$message.error("抱歉,您还未登录 !");
          this.$router.push({ path: '/login' });
        } else if (code === '2003') {
          this.$message.error("抱歉,非本学习班课程 !！");
          this.$router.push({ path: `/home/orderConfirm/${this.courseId}`});
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-card {
    border-bottom: 0;
    cursor: pointer;
    &:last-child {
      border-bottom: 1px solid #EBEEF5;
    }
  }

  .courseware-item {
    width: 99.5%;
    border-radius: 4px;
    &:hover {
      color: #409EFF;
      background-color: #E0EDF8;

      .download-tip {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }

  .download-tip {
    position: absolute;
    right: 10%;
    font-size: 25px;
    color: #409EFF;
    opacity: 0;

    transform: translateY(-10px);
    transition: all 0.3s linear;
  }

</style>
